// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3pXiF","gfeWrapper":"CalendarEvent_gfeWrapper__3mb6a"};